'use client'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { footerLinks1, footerLinks2, footerLinks3 } from '@/data/footer'

const week = [
  { value: 1, name: '星期一' },
  { value: 2, name: '星期二' },
  { value: 3, name: '星期三' },
  { value: 4, name: '星期四' },
  { value: 5, name: '星期五' },
  { value: 6, name: '星期六' },
  { value: 7, name: '星期日' },
]

export default function Footer8({ storeInfo }) {
  const footerTextAlign = storeInfo?.FooterTextAlign
  const companyAddress = storeInfo?.CompanyAddress
  const unitedID = storeInfo?.UnitedID
  const serviceTel = storeInfo?.ServiceTel

  const currentYear = new Date().getFullYear()
  const copyrightText = storeInfo.IsShowStartYear
    ? // ${storeInfo.BusinessID}
      `© ${storeInfo.StoreStartYear}-${currentYear} ${storeInfo.CompanyName}`
    : `© ${currentYear} ${storeInfo.CompanyName}`

  const footerInfoList = [
    companyAddress,
    serviceTel,
    unitedID ? `統編：${unitedID}` : '',
  ].filter((x) => x && String(x).trim() !== '')

  const spanStr =
    footerInfoList.length > 0
      ? `${copyrightText} | ${footerInfoList.join('  ')}`
      : copyrightText

  const serviceStartWeek = storeInfo?.ServiceStartWeek
    ? week.find((w) => w.value === storeInfo.ServiceStartWeek)?.name
    : ''
  const serviceEndWeek = storeInfo?.ServiceEndWeek
    ? week.find((w) => w.value === storeInfo.ServiceEndWeek)?.name
    : ''
  const serviceStartTime =
    storeInfo?.ServiceStartTime &&
    storeInfo.ServiceStartTime.slice(0, 2) +
      ':' +
      storeInfo.ServiceStartTime.slice(2)
  const serviceEndTime =
    storeInfo?.ServiceEndTime &&
    storeInfo.ServiceEndTime.slice(0, 2) +
      ':' +
      storeInfo.ServiceEndTime.slice(2)
  const bgColor = storeInfo?.PageFooterBGColor ?? '#000'

  return (
    <footer
      id="footer"
      className="footer footer-desktop bordered py-3"
      style={{ backgroundColor: bgColor }}
    >
      <div
        className="footer-middle container p-0"
        style={{
          maxWidth: '70%',
          margin: '0 auto',
        }}
      >
        {/* ====================== 手機版 ====================== */}
        <div
          className="d-block d-lg-none text-center"
          style={{
            paddingBottom: 'var(--mobile-footer-height, 72px)',
          }}
        >
          {/* Logo 區塊 */}
          <div className="mb-4">
            <Image
              loading="lazy"
              src={storeInfo?.PicturePath}
              alt="Store Logo"
              width={200}
              height={350}
              className="mb-3 mx-auto"
              style={{
                width: '200px',
                height: 'auto',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
            <ul className="list-unstyled small text-secondary">
              <li>{`客服電話: ${serviceTel}`}</li>
              <li>服務時間</li>
              {serviceStartWeek && serviceEndWeek && (
                <li>{`${serviceStartWeek} ~ ${serviceEndWeek}`}</li>
              )}
              {serviceStartTime && serviceEndTime && (
                <li>{`${serviceStartTime} ~ ${serviceEndTime}`}</li>
              )}
            </ul>
          </div>

          {/* 合併區塊（關於我們 + 購物 + 幫助） */}
          <div className="row">
            {/* 關於我們 */}
            <div className="col-4">
              <h6 className="fw-bold text-uppercase fs-6 mb-2 text-start">
                關於我們
              </h6>
              <ul className="list-unstyled text-start">
                {footerLinks1.map((elm, i) => (
                  <li key={i}>
                    <Link
                      href={elm.href}
                      className="text-dark text-decoration-none d-block py-1 text-start"
                    >
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* 購物 */}
            <div className="col-4">
              <h6 className="fw-bold text-uppercase fs-6 mb-2 text-start">
                購物
              </h6>
              <ul className="list-unstyled text-start">
                {footerLinks2.map((elm, i) => (
                  <li key={i}>
                    <Link
                      href={elm.href}
                      className="text-dark text-decoration-none d-block py-1 text-start"
                    >
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* 幫助 */}
            <div className="col-4">
              <h6 className="fw-bold text-uppercase fs-6 mb-2 text-start">
                幫助
              </h6>
              <ul className="list-unstyled text-start">
                {footerLinks3.map((elm, i) => (
                  <li key={i}>
                    <Link
                      href={elm.href}
                      className="text-dark text-decoration-none d-block py-1 text-start"
                    >
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className="mt-3"
            style={{ borderTop: '1px solid rgb(187, 185, 185)' }}
          >
            <span>{spanStr}</span>
          </div>
        </div>

        {/* ====================== 桌機版 ====================== */}
        <div className="d-none d-lg-block">
          <div
            className="d-flex justify-content-between flex-wrap text-center text-md-start"
            style={{ maxWidth: '700px', margin: '0 auto' }}
          >
            <div
              className="footer-menu d-flex flex-column"
              style={{ maxWidth: 250, flex: 1 }}
            >
              <Image
                loading="lazy"
                src={storeInfo?.PicturePath}
                alt="Store Logo"
                width={200}
                height={350}
                className="mb-4 mx-auto mx-md-0"
                style={{
                  width: '200px',
                  height: 'auto',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
              <ul className="sub-menu__list list-unstyled md-mt-4">
                <li className="sub-menu__item">{`客服電話: ${serviceTel}`}</li>
                <li className="sub-menu__item">服務時間</li>
                {serviceStartWeek && serviceEndWeek && (
                  <li className="sub-menu__item">{`${serviceStartWeek} ~ ${serviceEndWeek}`}</li>
                )}
                {serviceStartTime && serviceEndTime && (
                  <li className="sub-menu__item">{`${serviceStartTime} ~ ${serviceEndTime}`}</li>
                )}
              </ul>
            </div>

            <div
              className="footer-menu d-flex flex-column"
              style={{ maxWidth: 120, flex: 1 }}
            >
              <h6 className="sub-menu__title text-uppercase fs-5 mb-3">
                關於我們
              </h6>
              <ul className="sub-menu__list list-unstyled">
                {footerLinks1.map((elm, i) => (
                  <li key={i} className="sub-menu__item">
                    <Link href={elm.href} className="menu-link menu-link_us-s">
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div
              className="footer-menu d-flex flex-column"
              style={{ maxWidth: 120, flex: 1 }}
            >
              <h6 className="sub-menu__title text-uppercase fs-5 mb-3">購物</h6>
              <ul className="sub-menu__list list-unstyled">
                {footerLinks2.map((elm, i) => (
                  <li key={i} className="sub-menu__item">
                    <Link href={elm.href} className="menu-link menu-link_us-s">
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div
              className="footer-menu d-flex flex-column"
              style={{ maxWidth: 140, flex: 1 }}
            >
              <h6 className="sub-menu__title text-uppercase fs-5 mb-3">幫助</h6>
              <ul className="sub-menu__list list-unstyled">
                {footerLinks3.map((elm, i) => (
                  <li key={i} className="sub-menu__item">
                    <Link href={elm.href} className="menu-link menu-link_us-s">
                      {elm.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            style={{
              borderTop: '1px solid rgb(187, 185, 185)',
              textAlign: footerTextAlign,
            }}
          >
            <span>{spanStr}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
